// src/services/api/location.js
import { apiClient } from './base';

export const searchLocation = async (query) => {
  const response = await apiClient.post('/location/search', { query });
  return response.data;
};

export const reverseGeocodeLocation = async (latitude, longitude) => {
  const response = await apiClient.post('/location/reverse', { latitude, longitude });
  return response.data;
};

export const resolveGoogleMapsLink = async (url) => {
  const response = await apiClient.post('/location/resolve-link', { url });
  return response.data;
};
